<template>
  <div class="m-0 dbozone-font body">
    <div>
      <div class="col-12 justify-content-center d-flex flex-row header-clashofwars">
        <div class="px-3 col-3 p-0">
          <div class="heading-clashofwars">{{ $t("result.round") }}</div>
          <div class="text-subhead-clashofwars">{{ data.roundId }}</div>
        </div>
        <div class="px-3 col-3">
          <div class="heading-clashofwars">
            {{ $t("result.bet") + `${currency}` }}
          </div>
          <div class="text-subhead-clashofwars">
            {{ data.count === 0
              ? data.bet
              : data.detail.summary[data.count].bet.amount | currencyFormatter }}
          </div>
        </div>
        <div class="px-3 col-3">
          <div class="heading-clashofwars">
            {{ $t("result.winlose") + `${currency}` }}
          </div>
          <div class="text-subhead-clashofwars">
            {{ winlose | currencyFormatter }}
          </div>
        </div>
        <div class="px-3 col-3">
          <div class="heading-clashofwars">
            {{ $t("result.balance") + `${currency}` }}
          </div>
          <div class="text-subhead-clashofwars">
            {{ balance | currencyFormatter }}
          </div>
        </div>
      </div>
      <div class="content-result-clashofwars pt-3">
        <div class="text-games-clashofwars">{{ "Clash of war" }}</div>
        <div class="text-subgame-clashofwars">{{ $t("clashofwars.name") }}</div>
        <div class="text-date mb-1">{{ data.timestamp  }}</div>
        <div class="col-12 justify-content-center d-flex flex-row p-0" style="margin-top: 50px">
          <div class="col-1 d-flex align-items-center justify-content-center" style="color: white">
            <i v-if="isFreespin || isRespin || isGamble" class="fas fa-caret-left arrow-side-clashofwars"
              @click="delCount()"></i>
          </div>

          <!-- <div class="d-flex col-10 table-clashofwars container" /> -->
          <!-- <div v-if="this.isGamble === true">
            <div v-if="this.freeSpinData.gamble != '-'">
              <div class="d-flex flex-column align-items-center justify-content-center pt-10">
                <img class="gamble-img-clashofwars" :src="require(`../../assets/resultGame/clashofwars/gamble/history_${this.winGambleText}.png`)
                  " alt="" />
              </div>
              <div class="d-flex flex-column align-items-center justify-content-center">
                <img class="gamble-img-clashofwars" :src="require(`../../assets/resultGame/clashofwars/gamble/wheel_${this.freeSpinData.gambleThisRound}_${this.winGambleText}.png`)
                  " alt="" />
              </div>
            </div>
            <div v-else-if="this.freeSpinData.gamble == '-'">
              <div class="d-flex flex-column align-items-center justify-content-center">
                <div class="text-collect-clashofwars d-flex">
                  {{ $t("result.collect") + " = " }}
                  {{ this.freeSpinData.totalWin | currencyFormatter }}
                  {{ `${currency}` }}
                </div>
                <img class="gamble-img-clashofwars" :src="require(`../../assets/resultGame/clashofwars/gamble/btn_collect.png`)
                  " alt="" />
              </div>
            </div>
            <div v-if="this.freeSpinData.gamble === 'LOW'">
              <div class="col-12 justify-content-center d-flex flex-row">
                <img class="gamble-press-clashofwars pt-0" :src="require(`../../assets/resultGame/clashofwars/gamble/btn_LOW_${this.winGambleText}.png`)
                  " alt="" />
                <img class="gamble-normal-clashofwars pt-2" :src="require(`../../assets/resultGame/clashofwars/gamble/btn_HIGH_normal.png`)
                  " alt="" />
              </div>
            </div>
            <div v-else-if="this.freeSpinData.gamble === 'HIGH'">
              <div class="col-12 justify-content-center d-flex flex-row">
                <img class="gamble-press-clashofwars pt-2" :src="require(`../../assets/resultGame/clashofwars/gamble/btn_LOW_normal.png`)
                  " alt="" />
                <img class="gamble-normal-clashofwars pt-0" :src="require(`../../assets/resultGame/clashofwars/gamble/btn_HIGH_${this.winGambleText}.png`)
                  " alt="" />
              </div>
            </div>
          </div>
          <div v-else> -->
          <div class="d-flex flex-column">
            <div class="top-reel justify-content-center">
              <div class="" v-for="(row, index) in reels[6]" :key="index">
                <img class="icon-symbol-clashofwars" :src="require(`../../assets/resultGame/clashofwars/1/symbol_${row}.png`)
                  " alt="" />
              </div>
            </div>

            <div class="d-flex flex-row slot-container">

              <div class="d-flex flex-column">
                <div v-for="(reel, index) in this.newReel[0]" :key="index">
                  <img v-if="reel[0] >= 0 && reel[0] <= 12" class="icon-symbol-clashofwars" :src="require(`../../assets/resultGame/clashofwars/${reel[1]}/symbol_${reel[0]}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 13 && reel[0] <= 23" class="icon-symbol-clashofwars" :class="`-level${reel[1]}`"
                    :src="require(`../../assets/resultGame/clashofwars/${reel[1]
                      }/symbol_${reel[0] - 13}.png`)
                      " alt="" />
                  <img v-if="reel[0] >= 13 && reel[0] <= 23" class="icon-symbol" :class="`-level${reel[1]}`" :src="require(`../../assets/resultGame/clashofwars/silver${reel[1]}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 24 && reel[0] <= 34" class="icon-symbol-clashofwars" :src="require(`../../assets/resultGame/clashofwars/${reel[1]
                    }/symbol_${reel[0] - 24}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 24 && reel[0] <= 34" class="icon-symbol" :class="`-level${reel[1]}`" :src="require(`../../assets/resultGame/clashofwars/gold${reel[1]}.png`)
                    " alt="" />

                  <img v-if="expandIndex.includes(0) && index === 0" class="expanding-wild"
                    :src="require(`../../assets/resultGame/clashofwars/${reel[1]}/symbol_13.png`)" alt="" />

                  <img v-if="expandIndex.includes(0) && index === 2" class="expanding-wild" style="top: 60%;"
                    :src="require(`../../assets/resultGame/clashofwars/multiplier/x${reelsMultiplier[0]}.png`)"
                    alt="" />

                  <!-- <img v-if="index == 0 && winlines.includes(0)" class="line-overlay" style="padding-top: 15.5%;"
                    :src="require(`../../assets/resultGame/clashofwars/line/line1.png`)" alt="" />
                  <img v-if="index == 0 && winlines.includes(5)" class="line-overlay"
                    style="padding-top: 78%;height: 181.5%;"
                    :src="require(`../../assets/resultGame/clashofwars/line/line2.png`)" alt="" />
                  <img v-if="index == 0 && winlines.includes(7)" class="line-overlay" style="padding-top: 32%;"
                    :src="require(`../../assets/resultGame/clashofwars/line/line4.png`)" alt="" />

                  <img v-if="index == 1 && winlines.includes(1)" class="line-overlay" style="padding-top: 15.5%;"
                    :src="require(`../../assets/resultGame/clashofwars/line/line1.png`)" alt="" />
                  <img v-if="index == 1 && winlines.includes(8)" class="line-overlay" style="padding-top: 32%;"
                    :src="require(`../../assets/resultGame/clashofwars/line/line4.png`)" alt="" />
                  <img v-if="index == 1 && winlines.includes(9)" class="line-overlay"
                    :src="require(`../../assets/resultGame/clashofwars/line/line5.png`)" alt="" />


                  <img v-if="index == 2 && winlines.includes(2)" class="line-overlay" style="padding-top: 15.5%;"
                    :src="require(`../../assets/resultGame/clashofwars/line/line1.png`)" alt="" />
                  <img v-if="index == 2 && winlines.includes(10)" class="line-overlay" style="padding-top: 32%;"
                    :src="require(`../../assets/resultGame/clashofwars/line/line4.png`)" alt="" />
                  <img v-if="index == 2 && winlines.includes(11)" class="line-overlay"
                    :src="require(`../../assets/resultGame/clashofwars/line/line5.png`)" alt="" />

                  <img v-if="index == 3 && winlines.includes(3)" class="line-overlay" style="padding-top: 15.5%;"
                    :src="require(`../../assets/resultGame/clashofwars/line/line1.png`)" alt="" />
                  <img v-if="index == 3 && winlines.includes(12)" class="line-overlay" style="padding-top: 32%;"
                    :src="require(`../../assets/resultGame/clashofwars/line/line4.png`)" alt="" />
                  <img v-if="index == 3 && winlines.includes(13)" class="line-overlay"
                    :src="require(`../../assets/resultGame/clashofwars/line/line5.png`)" alt="" />

                  <img v-if="index == 4 && winlines.includes(4)" class="line-overlay" style="padding-top: 15.5%;"
                    :src="require(`../../assets/resultGame/clashofwars/line/line1.png`)" alt="" />
                  <img v-if="index == 4 && winlines.includes(6)" class="line-overlay"
                    style="padding-bottom: 47%;height: 142%;width: 129%;"
                    :src="require(`../../assets/resultGame/clashofwars/line/line3.png`)" alt="" />
                  <img v-if="index == 4 && winlines.includes(14)" class="line-overlay"
                    :src="require(`../../assets/resultGame/clashofwars/line/line5.png`)" alt="" /> -->

                </div>
              </div>

              <div class="d-flex flex-column">
                <div class="" v-for="(reel, index) in this.newReel[1]" :key="index">
                  <img v-if="reel[0] >= 0 && reel[0] <= 12" class="icon-symbol-clashofwars" :src="require(`../../assets/resultGame/clashofwars/${reel[1]}/symbol_${reel[0]}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 13 && reel[0] <= 23" class="icon-symbol-clashofwars" :src="require(`../../assets/resultGame/clashofwars/${reel[1]
                    }/symbol_${reel[0] - 13}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 13 && reel[0] <= 23" class="icon-symbol" :class="`-level${reel[1]}`" :src="require(`../../assets/resultGame/clashofwars/silver${reel[1]}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 24 && reel[0] <= 34" class="icon-symbol-clashofwars" :src="require(`../../assets/resultGame/clashofwars/${reel[1]
                    }/symbol_${reel[0] - 24}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 24 && reel[0] <= 34" class="icon-symbol" :class="`-level${reel[1]}`" :src="require(`../../assets/resultGame/clashofwars/gold${reel[1]}.png`)
                    " alt="" />

                  <img v-if="expandIndex.includes(1) && index === 0" class="expanding-wild"
                    :src="require(`../../assets/resultGame/clashofwars/${reel[1]}/symbol_13.png`)" alt="" />

                  <img v-if="expandIndex.includes(1) && index === 2" class="expanding-wild" style="top: 60%;"
                    :src="require(`../../assets/resultGame/clashofwars/multiplier/x${reelsMultiplier[1]}.png`)"
                    alt="" />
                </div>
              </div>

              <div class="d-flex flex-column">
                <div class="" v-for="(reel, index) in this.newReel[2]" :key="index">
                  <img v-if="reel[0] >= 0 && reel[0] <= 12" class="icon-symbol-clashofwars" :class="`-level${reel[1]}`"
                    :src="require(`../../assets/resultGame/clashofwars/${reel[1]}/symbol_${reel[0]}.png`)
                      " alt="" />
                  <img v-if="reel[0] >= 13 && reel[0] <= 23" class="icon-symbol-clashofwars" :src="require(`../../assets/resultGame/clashofwars/${reel[1]
                    }/symbol_${reel[0] - 13}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 13 && reel[0] <= 23" class="icon-symbol" :class="`-level${reel[1]}`" :src="require(`../../assets/resultGame/clashofwars/silver${reel[1]}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 24 && reel[0] <= 34" class="icon-symbol-clashofwars" :src="require(`../../assets/resultGame/clashofwars/${reel[1]
                    }/symbol_${reel[0] - 24}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 24 && reel[0] <= 34" class="icon-symbol" :class="`-level${reel[1]}`" :src="require(`../../assets/resultGame/clashofwars/gold${reel[1]}.png`)
                    " alt="" />

                  <img v-if="expandIndex.includes(2) && index === 0" class="expanding-wild"
                    :src="require(`../../assets/resultGame/clashofwars/${reel[1]}/symbol_13.png`)" alt="" />

                  <img v-if="expandIndex.includes(2) && index === 2" class="expanding-wild" style="top: 60%;"
                    :src="require(`../../assets/resultGame/clashofwars/multiplier/x${reelsMultiplier[2]}.png`)"
                    alt="" />
                </div>
              </div>

              <div class="d-flex flex-column">
                <div class="" v-for="(reel, index) in this.newReel[3]" :key="index">
                  <img v-if="reel[0] >= 0 && reel[0] <= 12" class="icon-symbol-clashofwars" :src="require(`../../assets/resultGame/clashofwars/${reel[1]}/symbol_${reel[0]}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 13 && reel[0] <= 23" class="icon-symbol-clashofwars" :src="require(`../../assets/resultGame/clashofwars/${reel[1]
                    }/symbol_${reel[0] - 13}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 13 && reel[0] <= 23" class="icon-symbol" :class="`-level${reel[1]}`" :src="require(`../../assets/resultGame/clashofwars/silver${reel[1]}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 24 && reel[0] <= 34" class="icon-symbol-clashofwars" :src="require(`../../assets/resultGame/clashofwars/${reel[1]
                    }/symbol_${reel[0] - 24}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 24 && reel[0] <= 34" class="icon-symbol" :class="`-level${reel[1]}`" :src="require(`../../assets/resultGame/clashofwars/gold${reel[1]}.png`)
                    " alt="" />

                  <img v-if="expandIndex.includes(3) && index === 0" class="expanding-wild"
                    :src="require(`../../assets/resultGame/clashofwars/${reel[1]}/symbol_13.png`)" alt="" />

                  <img v-if="expandIndex.includes(3) && index === 2" class="expanding-wild" style="top: 60%;"
                    :src="require(`../../assets/resultGame/clashofwars/multiplier/x${reelsMultiplier[3]}.png`)"
                    alt="" />
                </div>
              </div>
              <div class="d-flex flex-column">
                <div class="" v-for="(reel, index) in this.newReel[4]" :key="index">
                  <img v-if="reel[0] >= 0 && reel[0] <= 12" class="icon-symbol-clashofwars" :src="require(`../../assets/resultGame/clashofwars/${reel[1]}/symbol_${reel[0]}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 13 && reel[0] <= 23" class="icon-symbol-clashofwars" :src="require(`../../assets/resultGame/clashofwars/${reel[1]
                    }/symbol_${reel[0] - 13}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 13 && reel[0] <= 23" class="icon-symbol" :class="`-level${reel[1]}`" :src="require(`../../assets/resultGame/clashofwars/silver${reel[1]}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 24 && reel[0] <= 34" class="icon-symbol-clashofwars" :src="require(`../../assets/resultGame/clashofwars/${reel[1]
                    }/symbol_${reel[0] - 24}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 24 && reel[0] <= 34" class="icon-symbol" :class="`-level${reel[1]}`" :src="require(`../../assets/resultGame/clashofwars/gold${reel[1]}.png`)
                    " alt="" />

                  <img v-if="expandIndex.includes(4) && index === 0" class="expanding-wild"
                    :src="require(`../../assets/resultGame/clashofwars/${reel[1]}/symbol_13.png`)" alt="" />

                  <img v-if="expandIndex.includes(4) && index === 2" class="expanding-wild" style="top: 60%;"
                    :src="require(`../../assets/resultGame/clashofwars/multiplier/x${reelsMultiplier[4]}.png`)"
                    alt="" />
                </div>
              </div>

              <div class="d-flex flex-column">
                <div class="" v-for="(reel, index) in this.newReel[5]" :key="index">
                  <img v-if="reel[0] >= 0 && reel[0] <= 12" class="icon-symbol-clashofwars" :src="require(`../../assets/resultGame/clashofwars/${reel[1]}/symbol_${reel[0]}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 13 && reel[0] <= 23" class="icon-symbol-clashofwars" :src="require(`../../assets/resultGame/clashofwars/${reel[1]
                    }/symbol_${reel[0] - 13}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 13 && reel[0] <= 23" class="icon-symbol" :class="`-level${reel[1]}`" :src="require(`../../assets/resultGame/clashofwars/${reel[1]
                    }/symbol_${reel[0] - 13}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 24 && reel[0] <= 34" class="icon-symbol-clashofwars" :src="require(`../../assets/resultGame/clashofwars/${reel[1]
                    }/symbol_${reel[0] - 24}.png`)
                    " alt="" />
                  <img v-if="reel[0] >= 24 && reel[0] <= 34" class="icon-symbol" :class="`-level${reel[1]}`" :src="require(`../../assets/resultGame/clashofwars/gold${reel[1]}.png`)
                    " alt="" />

                  <img v-if="expandIndex.includes(5) && index === 0" class="expanding-wild"
                    :src="require(`../../assets/resultGame/clashofwars//${reel[1]}/symbol_13.png`)" alt="" />

                  <img v-if="expandIndex.includes(5) && index === 2" class="expanding-wild" style="top: 60%;"
                    :src="require(`../../assets/resultGame/clashofwars/multiplier/x${reelsMultiplier[5]}.png`)"
                    alt="" />
                </div>
              </div>

              <div class="d-flex flex-column">
                <div v-for="(reel, index) in this.newReel[0]" :key="index">

                  <img v-if="index == 0 && winlines.includes(0)" class="line-overlay" style="padding-top: 15.5%;"
                    :src="require(`../../assets/resultGame/clashofwars/line/line1.png`)" alt="" />
                  <img v-if="index == 0 && winlines.includes(5)" class="line-overlay"
                    style="padding-top: 77.5%;height: 180%;"
                    :src="require(`../../assets/resultGame/clashofwars/line/line2.png`)" alt="" />
                  <img v-if="index == 0 && winlines.includes(7)" class="line-overlay" style="padding-top: 32%;"
                    :src="require(`../../assets/resultGame/clashofwars/line/line4.png`)" alt="" />

                  <img v-if="index == 1 && winlines.includes(1)" class="line-overlay" style="padding-top: 46.5%;"
                    :src="require(`../../assets/resultGame/clashofwars/line/line1.png`)" alt="" />
                  <img v-if="index == 1 && winlines.includes(8)" class="line-overlay" style="padding-top: 30.5%;"
                    :src="require(`../../assets/resultGame/clashofwars/line/line5.png`)" alt="" />
                  <img v-if="index == 1 && winlines.includes(9)" class="line-overlay" style="padding-top: 62.5%;"
                    :src="require(`../../assets/resultGame/clashofwars/line/line4.png`)" alt="" />


                  <img v-if="index == 2 && winlines.includes(2)" class="line-overlay" style="padding-top: 77.5%;"
                    :src="require(`../../assets/resultGame/clashofwars/line/line1.png`)" alt="" />
                  <img v-if="index == 2 && winlines.includes(10)" class="line-overlay" style="padding-top: 62%;"
                    :src="require(`../../assets/resultGame/clashofwars/line/line5.png`)" alt="" />
                  <img v-if="index == 2 && winlines.includes(11)" class="line-overlay" style="padding-top: 93.5%;"
                    :src="require(`../../assets/resultGame/clashofwars/line/line4.png`)" alt="" />

                  <img v-if="index == 3 && winlines.includes(3)" class="line-overlay" style="padding-top: 108.5%;"
                    :src="require(`../../assets/resultGame/clashofwars/line/line1.png`)" alt="" />
                  <img v-if="index == 3 && winlines.includes(12)" class="line-overlay" style="padding-top: 92.5%;"
                    :src="require(`../../assets/resultGame/clashofwars/line/line5.png`)" alt="" />
                  <img v-if="index == 3 && winlines.includes(13)" class="line-overlay" style="padding-top: 124.5%;"
                    :src="require(`../../assets/resultGame/clashofwars/line/line4.png`)" alt="" />

                  <img v-if="index == 4 && winlines.includes(4)" class="line-overlay" style="padding-top: 139.5%;"
                    :src="require(`../../assets/resultGame/clashofwars/line/line1.png`)" alt="" />
                  <img v-if="index == 4 && winlines.includes(6)" class="line-overlay"
                    style="height: 181%;padding-top: 78.5%;"
                    :src="require(`../../assets/resultGame/clashofwars/line/line3.png`)" alt="" />
                  <img v-if="index == 4 && winlines.includes(14)" class="line-overlay" style="padding-top: 124%;"
                    :src="require(`../../assets/resultGame/clashofwars/line/line5.png`)" alt="" />

                </div>
              </div>
            </div>
          </div>

          <!-- </div> -->

          <div class="col-1 d-flex align-items-center justify-content-center">
            <i v-if="!isEndRound" class="fas fa-caret-right arrow-side-clashofwars" @click="addCount()"></i>
          </div>
        </div>
        <div class="text-center py-4 text-games-clashofwars">
          <h1 v-if="isFreespin">
            FREESPIN {{ data.count + 1 }}/{{ data.detail.summary.length }}
          </h1>
          <h1 v-else>{{ $t("main-game.spin") }} {{ data.count + 1 }}/{{ data.detail.summary.length }}</h1>
        </div>
        <div v-if="winnings.length > 0" class="col-12 justify-content-center d-flex flex-row">
          <hr class="line col-3" />
          <div class="text-detail align-items-center d-flex px-3">
            {{ $t("result.detail") }}
          </div>
          <hr class="line col-3" />
        </div>
        <div v-if="data.detail.featureBuy" class="text-subgame-clashofwars">
          Feature Buy
        </div>

        <!-- <div v-if="data.detail.winnings.length" class="col-12 justify-content-start d-flex flex-row">
          <div class="bet-box-clashofwars p-2 px-3 justify-content-start align-items-start container" style="width: 100%; align-content: center;">
            <div class="text-multiplier">
              <h1 class="my-1 green">Multiplier x {{ this.multiplier }}</h1>
            </div>
            <div class="bet-warpper item" v-for="(detail, index) in data.detail.winnings" :key="index">
              <div class="d-flex item justify-content-between px-1 mb-2" >
                <div class="bet-wrapper-clashofwars item win-box d-flex" >
                  <div class="d-flex justify-content-between bet-wrapper-clashofwars item">
                    <div class="d-flex flex-row">
                      <img class="icon-detail-clashofwars" :src="require(`../../assets/resultGame/clashofwars/1/symbol_${detail.symbol}.png`)
                        " alt="" />
                      <div class="d-flex flex-column align-items-start justify-content-center">
                        <p class="my-1 green ml-2">
                          {{
                            ` ${detail.row} ` +
                            $t("result.kind") +
                            ` x${detail.count} ${detail.count > 1 ? `lines` : `line`
                            }`
                          }}
                        </p>
                      </div>
                    </div>
                    <div class="d-flex flex-column justify-content-center px-3">
                      <p class="my-1">
                        {{ currency }} {{ detail.amount | currencyFormatter }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
        <div v-if="winnings.length" class="col-12 justify-content-start d-flex flex-row">
          <div class=" p-2 px-3 justify-content-start align-items-center container">
            <!-- <div class="text-multiplier">
              <h1 class="my-1 green">Multiplier x {{ this.multiplier }}</h1>
            </div> -->
            <div class="bet-wrapper justify-content-between item d-flex flex-row col-12"
              v-for="(detail, index) in winnings" :key="index">
              <div class="d-flex flex-row">
                <img class="icon-detail-clashofwars"
                  :src="require(`../../assets/resultGame/clashofwars/1/symbol_${detail.symbol}.png`)" alt="" />
                <div style="margin-left:10px" class=" d-flex text-win align-items-center 
                            justify-content-center">
                  <p class="my-1">
                    <span class="line-text">{{ $t("result.line") + ` ${detail.line + 1}` }}</span>
                    <span class="my-1 green">{{ ' - ' + detail.count + ' ' + $t("result.kind") }}</span>
                    <span class="multiplier-text">{{ ` X${detail.multiplier}` }}</span>
                  </p>

                </div>
              </div>
              <div class="d-flex text-win justify-content-center align-items-center px-3">
                <p class="my-1 green"> {{ currency }} {{ detail.amount | currencyFormatter }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from "../../services/utils";
export default {
  name: "result-clashofwars",
  props: {
    data: Object,
    page: Number,
    isback: Boolean
  },
  data() {
    return {
      headerHeight: null,
      dateTimeFormatter: function formatter(date) {
        return utils.dateTimeFormatter(date);
      },
      tokenData: utils.getTokenData(this.$route.query.t)
      ,
      date: "",
      time: "",
      currency: this.data.currency ? this.data.currency : "THB",
      ratecurrency: this.data.rateCurrency ? this.data.rateCurrency : 1,
      isFreespin: false,
      multiplier: 0,
      reels: [],
      reelSizes: [],
      newReel: [],
      isEndRound: false,
      pages: 0,
      allWinLines: [[1, 6, 8], [2, 9, 10], [3, 11, 12], [4, 13, 14], [5, 7, 15]],
      winlines: [],
      expandIndex: [],
      reelsMultiplier: []
    };
  },
  async created() {
    if (this.isback) {
      this.data.count = this.data.detail.summary.length - 1;
      await this.mapSymbol(this.data.detail.summary[this.data.count]);
    }
    else {
      this.data.count = 0;
      await this.mapSymbol(this.data.detail.summary[this.data.count]);
    }
  },
  methods: {
    onResize() {
      this.headerHeight =
        document.getElementsByClassName("header-clashofwars")[0].offsetHeight;
    },
    async mapSymbol(result) {
      if (!this.currency.includes("(")) {
        this.currency = this.tokenData.isSymb === false ? '' : `(${this.currency})`;
      }
      this.isGamble = result.state === "GAMBLE" ? true : false;
      this.freeSpinData = result.freeSpin;
      this.freeSpinData.gambleThisRound = this.freeSpinData.gamble;
      this.winGambleText = this.freeSpinData.totalWin > 0 ? "win" : "lose";
      if (this.freeSpinData.totalWin <= 0) {
        this.freeSpinData.gambleThisRound =
          this.freeSpinData.gamble == "LOW" ? "HIGH" : "LOW";
      }
      this.isFreespin =
        result.state === "FREESPIN" ||
        result.state === "FREERESPIN";
      this.isRespin = result.state === "RESPIN";

      this.reelSizes = [[1, 1, 1, 1, 1], [1, 1, 1, 1, 1], [1, 1, 1, 1, 1], [1, 1, 1, 1, 1], [1, 1, 1, 1, 1]];
      this.multiplier = result.multiplier;

      this.reels = result.reels;
      this.isEndRound = result.isEndRound;
      this.winlose = result.win;
      this.bet = result.bet;
      this.balance = result.balance;
      this.winnings = result.winnings;
      this.reelsMultiplier = result.reelsMultiplier;
      this.expandIndex = await this.checkWildArray(result.reels);

      this.winlines = [];
      result.winnings.forEach(detail => {
        this.winlines.push(detail.line)
      });

      this.newReel = await this.mapTable(this.reels, this.reelSizes);

      if (result.isCoin) this.currency = 'AMS';
    },
    async addCount() {
      this.data.count += 1;
      if (this.data.count > this.data.detail.summary.length - 1) {
        this.pages += 1;
        this.$emit('fetchResult', this.page + 1)
      } else {
        await this.mapSymbol(this.data.detail.summary[this.data.count]);
      }

    },
    async delCount() {
      this.data.count -= 1;
      if (this.page > 0) {
        this.pages -= 1;
        this.$emit('fetchResult', this.page - 1, true)
      } else {
        await this.mapSymbol(this.data.detail.summary[this.data.count]);
      }
    },
    async mapTable(reel, reelSize) {
      let newMap = [];
      let newReel = [];
      for (let i = 0; i < reel.length; i++) {
        newReel = [];
        for (let j = 0; j < reel[i].length; j++) {
          let symbolMap = [reel[i][j], reelSize[i][j]];
          newReel.push(symbolMap);
        }
        newMap.push(newReel);
      }
      return newMap;
    },
    checkWildArray(reelsData) {
      return new Promise((resolve, reject) => {
        const wildArray = [10, 10, 10, 10, 10];
        const expandIndex = []
        try {
          reelsData.forEach((reel, index) => {
            if (JSON.stringify(reel) === JSON.stringify(wildArray)) {
              expandIndex.push(index)
            }
          })
          resolve(expandIndex);
        } catch (error) {
          reject(error);
        }
      })
    },
    setMultiplierPosition(value) {
      let translateX = '10%';

      if (value >= 100) {
        translateX = '10%';
      } else if (value >= 10) {
        translateX = '30%';
      } else {
        translateX = '70%';
      }

      return {
        transform: `translateX(${translateX})`
      };
    }
  },
};
</script>

<style scoped>
body {
  font-family: "Prompt", sans-serif;
  background-color: #292933;
  /* margin: 0; */
}

img {
  pointer-events: none;
  cursor: default;
}

.wheel-wrapper {
  position: absolute;
  width: 570px;
  height: 100%;
  top: 7px;
}

.fg-image {
  width: 570px;
}


.multiplier-wrapper {
  top: -95px;
  z-index: 6;
  height: 134px;
  overflow: hidden;
}

.multiplier-image {
  width: 90%;
  transform: scale(0.9);
  margin-left: 21px;
}

.icon-detail-clashofwars {
  width: 100px;
  height: 80px;
  padding: 4px;
}

.icon-bonus-clashofwars {
  width: 100px;
  height: 100px;
  padding: 10px;
}

.arrow {
  color: #cac095;
  text-align: center;
}

.arrow-side-clashofwars {
  cursor: pointer;
  color: #ffff;
  text-align: center;
  font-size: 90px;
}

.arrow-side-monster:hover {
  color: #06112d;
  text-align: center;
  /* font-size: 90px; */
}

.bet-box-clashofwars {
  /* background: #0c161f; */
  border-radius: 10px;
  min-height: 200px;
  max-height: 300px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.bonus-box-clashofwars {
  background: #0c161f;
  border-radius: 10px;
  min-height: 150px;
  max-height: 300px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bet-wrapper-clashofwars .item {
  color: #fff;
  /* background: #06112d; */
  line-height: 1;
  border-radius: 10px;
  /* border: 1.5px solid #cac095; */
}

.bet-box-clashofwars .bet-wrapper-clashofwars:not(:first-child) .item {
  /* margin-top: 10px;
  width: 800px; */
}

.bet-wrapper-clashofwars,
.result-wrapper {
  font-size: 35px;
  width: 800px;
}

.header-clashofwars {
  background: #FF9800;
  padding: 10px 0;
  flex-wrap: wrap;
}

.header-clashofwars>div {
  flex-grow: 1;
  font-size: 20px;
  line-height: 1.1;
}

.heading-clashofwars {
  color: #000000;
  text-align: center;
}

.content-result-clashofwars {
  background: #1C0804;
  height: 160vh;
  width: 100%;
  background-size: cover;
  background-attachment: scroll;
  background-repeat: no-repeat;
}

.title>.heading-clashofwars {
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 0;
}

.title>.sub {
  font-size: 30px;
  line-height: 1;
}

.text-games-clashofwars {
  color: #ffffff;
  font-size: 25px;
  text-align: center;
}

.text-collect-clashofwars {
  color: #fff;
  font-size: 25px;
  text-align: center;
}

.text-subhead-clashofwars {
  font-size: px;
  color: #fff;
  text-align: center;
}

.text-subgame-clashofwars {
  font-size: 20px;
  color: #ffd500;
  text-align: center;
}

.text-date {
  font-size: px;
  color: #fff;
  text-align: center;
}

.text-detail {
  font-size: 20px;
  color: #fff;
  text-align: center;
}

.icon-symbol-clashofwars {
  width: 100%;
  /* height: 100%; */
  /* padding: 5%; */
}

.gamble-normal-clashofwars {
  width: 40%;
  height: 35%;
  /* padding: 5%; */
}

.gamble-press-clashofwars {
  width: 40%;
  height: 40%;
  /* padding: 5%; */
}

.gamble-img-clashofwars {
  width: 70%;
  height: 70%;
  /* padding: 5%; */
}

.bet-box-clashofwars {
  /* min-width: 600px;
  max-width: auto; */
}

.win-box {
  width: 760px;
}

.icon-symbol {
  position: absolute;
  transform: translate(-100%, 0%);
  width: 16.75%;
  /* height: 100%; */
}

.position-relative {
  position: relative;
}

.line-overlay {
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 130%;
  pointer-events: none;
}

.expanding-wild {
  position: absolute;
  /* left: 50%; */
  transform: translate(-97%, -0%);
  width: 21%;
  pointer-events: none;
}

.overlay-text {
  position: absolute;
  top: 57%;
  pointer-events: none;
  text-align: center;
  font-weight: 600;
  font-size: calc(40px + 1vw);
  margin: 0;
  padding: 0;
  color: #ffd500;
  -webkit-text-stroke: 2.5px black;
}

.line-text,
.multiplier-text {
  color: #FF8D00;
}


/* .icon-symbol.-level1 {
  width: 120;
  height: 89px;
}

.icon-symbol.-level2 {
  width: 120;
  height: 128;
  margin-left: -12px;
}

.icon-symbol.-level3 {
  width: 120;
  height: 330px;
  margin-left: -12px;
}

.icon-symbol.-level4 {
  width: 120;
  height: 442px;
  margin-left: -12px;
} */

.table-clashofwars {
  /* background: url("~@/assets/resultGame/clashofwars/slotmachine.png") no-repeat; */
  z-index: 5;
  background-size: 763px 186px;
  /* set Bg Table HERE */
  width: 763px;
  height: 268px;
  border-radius: 5px;
  font-size: 30px;
  text-align: center;
  margin-top: 48px;
  position: absolute;
  z-index: 0;
  transform: translate(0px, -130px);
}

.slot-container {
  position: relative;
  align-self: center;
  width: 100%;
  clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%);
}

.top-reel {
  display: flex;
  flex-direction: row;
  position: relative;
  width: 67%;
  transform: translate(24.5%, 0%);
}

.table-pos {
  transform: translate(0px, -7px);
}

.text-multiplier {
  width: 100%;
  text-align: center;
}

.line {
  background-color: #fff;
  height: 2px;
  width: 100%;
  font-size: 28px;
}

.red {
  color: #ff0000;
}

.green {
  color: #fff;
  font-size: 28px;
}

.win-box {
  width: 689px;
}





@media screen and (max-width: 1030px) {
  .table-clashofwars {
    background-size: 760px 181px;
    width: 760px;
    height: 268px;
    transform: translate(0px, -124px);
  }

  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .fg-image {
    width: 500px;
  }

  .multiplier-wrapper {
    top: -107px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .wrapper {
    flex-direction: column;
  }

  .wrapper>div:first-child {
    order: 2;
  }

  .wrapper>div:last-child {
    order: 1;
  }

  .arrow-side-monster {
    font-size: 60px;
  }

  .bet-box-clashofwars {
    /* min-width: 580px;
    max-width: auto;
    height: 280px; */
  }

  .bet-wrapper-clashofwars {
    width: 800px;
  }

  .result-wrapper {
    font-size: 35px;
    width: 800px;
  }

  .win-box {
    width: 689px;
  }
}

@media screen and (max-width: 1030px) {
  .table-clashofwars {
    background-size: 760px 640px;
    width: 760px;
    height: 640px;
    transform: translate(0px, -55px);
  }

  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .fg-image {
    width: 500px;
  }

  .multiplier-wrapper {
    top: -107px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .wrapper {
    flex-direction: column;
  }

  .wrapper>div:first-child {
    order: 2;
  }

  .wrapper>div:last-child {
    order: 1;
  }

  .arrow-side-monster {
    font-size: 60px;
  }

  .bet-box-clashofwars {
    /* min-width: 580px;
    max-width: auto; */
    /* height: 280px; */
  }

  .bet-wrapper-clashofwars {
    width: 800px
  }

  .result-wrapper {
    font-size: 35px;
    width: 800px
  }

  .win-box {
    width: 689px;
  }
}

@media screen and (min-width: 1060px) {
  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -115px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .fg-image {
    width: 570px;
    margin-left: -34px;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(1);
    margin-left: 21px;
  }

  .d-md-spec-flex {
    display: flex;
  }

  .result-wrapper .symbol {
    width: 140px;
  }

  .bet-wrapper-clashofwars,
  .result-wrapper {
    font-size: 33px;
    width: 800px;
  }
}

@media screen and (max-width: 900px) {
  .table-clashofwars {
    background-size: 747px 645px;
    width: 747px;
    height: 645px;
    transform: translate(0px, -58px);
  }
}

@media screen and (max-width: 870px) {
  .table-clashofwars {
    background-size: 729px 628px;
    width: 729px;
    height: 628px;
    transform: translate(-2px, -59px);
  }
}

@media screen and (max-width: 840px) {
  .table-clashofwars {
    background-size: 699px 602px;
    width: 699px;
    height: 602px;
    transform: translate(0px, -57px);
  }
}

@media screen and (max-width: 800px) {
  .table-clashofwars {
    background-size: 659px 569px;
    width: 659px;
    height: 569px;
    transform: translate(0px, -56px);
  }
}

@media screen and (max-width: 780px) {}

@media screen and (max-width: 770px) {
  .heading-clashofwars {
    font-size: 18px;
  }

  .table-clashofwars {
    background-size: 638px 550px;
    width: 638px;
    height: 550px;
    margin-bottom: 1%;
    transform: translate(0px, -55px);
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .text-subhead-clashofwars {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-clashofwars {
    /* min-width: 430px;
    max-width: auto; */
  }

  .text-date {
    font-size: 20px;
    color: #fff;
    text-align: center;
  }

  .win-box {
    width: 689px;
  }
}

@media screen and (max-width: 740px) {
  .heading-clashofwars {
    font-size: 18px;
  }

  .table-clashofwars {
    background-size: 614px 526px;
    width: 614px;
    height: 526px;
    margin-bottom: 1%;
    transform: translate(0px, -53px);
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .text-subhead-clashofwars {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-clashofwars {
    /* min-width: 430px;
    max-width: auto; */
  }

  .text-date {
    font-size: 20px;
    color: #fff;
    text-align: center;
  }

  .win-box {
    width: 689px;
  }
}

@media screen and (max-width: 710px) {
  .heading-clashofwars {
    font-size: 18px;
  }

  .table-clashofwars {
    background-size: 582px 500px;
    width: 582px;
    height: 500px;
    margin-bottom: 1%;
    transform: translate(-2px, -54px);
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .text-subhead-clashofwars {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-clashofwars {
    /* min-width: 430px;
    max-width: auto; */
  }

  .text-date {
    font-size: 20px;
    color: #fff;
    text-align: center;
  }

  .win-box {
    width: 689px;
  }
}

@media screen and (max-width: 680px) {
  .heading-clashofwars {
    font-size: 18px;
  }

  .table-clashofwars {
    background-size: 566px 482px;
    width: 566px;
    height: 482px;
    margin-bottom: 1%;
    transform: translate(-1px, -55px);
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .text-subhead-clashofwars {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-clashofwars {
    /* min-width: 430px;
    max-width: auto; */
  }

  .text-date {
    font-size: 20px;
    color: #fff;
    text-align: center;
  }

  .win-box {
    width: 689px;
  }
}

@media screen and (max-width: 650px) {
  .heading-clashofwars {
    font-size: 18px;
  }

  .table-clashofwars {
    background-size: 543px 470px;
    width: 543px;
    height: 470px;
    margin-bottom: 1%;
    transform: translate(0px, -56px);
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .text-subhead-clashofwars {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-clashofwars {
    /* min-width: 430px;
    max-width: auto; */
  }

  .text-date {
    font-size: 20px;
    color: #fff;
    text-align: center;
  }

  .win-box {
    width: 689px;
  }
}

@media screen and (max-width: 620px) {
  .heading-clashofwars {
    font-size: 18px;
  }

  .table-clashofwars {
    background-size: 516px 444px;
    width: 516px;
    height: 444px;
    margin-bottom: 1%;
    transform: translate(-2px, -53px);
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .text-subhead-clashofwars {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-clashofwars {
    /* min-width: 430px;
    max-width: auto; */
  }

  .text-date {
    font-size: 20px;
    color: #fff;
    text-align: center;
  }

  .win-box {
    width: 689px;
  }
}

@media screen and (max-width: 600px) {
  .table-clashofwars {
    background-size: 498px 430px;
    width: 498px;
    height: 430px;
    transform: translate(0px, -54px);
  }
}

@media screen and (max-width: 570px) {
  .table-clashofwars {
    background-size: 474px 410px;
    width: 474px;
    height: 410px;
    transform: translate(0px, -53px);
  }
}

@media screen and (max-width: 540px) {
  .table-clashofwars {
    background-size: 450px 390px;
    width: 450px;
    height: 390px;
    transform: translate(-1px, -54px);
  }

  .text-multiplier {
    width: 100%;
    text-align: center;
  }
}

@media screen and (max-width: 510px) {
  .table-clashofwars {
    background-size: 425px 367px;
    width: 425px;
    height: 367px;
    transform: translate(0px, -54px);
  }
}

@media screen and (max-width: 480px) {
  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .fg-image {
    width: 230px;
    height: 189px;
    margin-left: 135px;
    margin-top: -9px;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.4);
    margin-left: 21px;
  }

  .header-clashofwars>div {
    flex-grow: 0;
    width: 25%;
  }

  .heading-clashofwars {
    font-size: 12px;
  }

  .table-clashofwars {
    background-size: 399px 344px;
    width: 399px;
    height: 344px;
    transform: translate(-1px, -53px);
  }

  .text-subhead-clashofwars {
    font-size: 14px;
  }

  .bet-box-clashofwars {
    /* min-width: 230px;
    max-width: auto; */
    /* height: 200px; */
  }

  .bonus-box-clashofwars {
    min-width: 230px;
    max-width: auto;
    height: 150px;
  }

  .bet-wrapper-clashofwars {
    width: 422px;
  }

  .result-wrapper {
    font-size: 20px;
  }

  .icon-detail-clashofwars {
    width: 50px;
    height: 50px;
  }

  .text-win {
    height: 60px;
  }

  .text-multiplier {
    width: 100%;
    text-align: center;
  }

  .icon-bonus-clashofwars {
    width: 60px;
    height: 60px;
  }
}

@media screen and (max-width: 450px) {
  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .fg-image {
    width: 230px;
    height: 189px;
    margin-left: 135px;
    margin-top: -9px;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.4);
    margin-left: 21px;
  }

  .header-clashofwars>div {
    flex-grow: 0;
    width: 25%;
  }

  .heading-clashofwars {
    font-size: 12px;
  }

  .table-clashofwars {
    background-size: 375px 324px;
    width: 375px;
    height: 324px;
    transform: translate(-1px, -53px);
  }

  .text-subhead-clashofwars {
    font-size: 14px;
  }

  .bet-box-clashofwars {
    /* min-width: 230px;
    max-width: auto; */
    /* height: 200px; */
  }

  .bonus-box-clashofwars {
    min-width: 230px;
    max-width: auto;
    height: 150px;
  }

  .bet-wrapper-clashofwars {
    width: 422px;
  }

  .result-wrapper {
    font-size: 20px;
  }

  .icon-detail-clashofwars {
    width: 50px;
    height: 50px;
  }

  .text-multiplier {
    width: 100%;
    text-align: center;
  }

  .icon-bonus-clashofwars {
    width: 60px;
    height: 60px;
  }
}

@media screen and (max-width: 420px) {

  .table-clashofwars {
    background-size: 350px 300px;
    width: 350px;
    height: 300px;
    transform: translate(1px, -52px);
  }
}

@media screen and (max-width: 390px) {

  .table-clashofwars {
    background-size: 325px 280px;
    width: 325px;
    height: 280px;
    transform: translate(0px, -53px);
  }
}

@media screen and (max-width: 360px) {

  .table-clashofwars {
    background-size: 300px 100px;
    width: 399px;
    height: 180px;
    transform: translate(0px, -93px);
  }

}

@media screen and (max-width: 340px) {

  .table-clashofwars {
    background-size: 279px 100px;
    width: 399px;
    height: 180px;
    transform: translate(2px, -93px);
  }
}

@media screen and (max-width: 320px) {

  .table-clashofwars {
    background-size: 259px 64px;
    width: 399px;
    height: 180px;
    transform: translate(4px, -76px);
  }
}
</style>